/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { TextField, Box, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { useQuery, useMutation } from '@apollo/client';
import { BusinessOutlined, ExpandMore } from '@material-ui/icons';
import { GET_BRAND_BY_ID, EDIT_BRAND } from '../../queries/products/brand';
import useStyles from './styles';

const Brand = ({ brandId, save }) => {
  const [name, setName] = useState('');
  const [website, setWebsite] = useState('');
  const [address, setAddress] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [readOnlyWebsite, setReadOnlyWebsite] = useState(false);
  const [readOnlyAddress, setReadOnlyAddress] = useState(false);
  const [readOnlyState, setReadOnlyState] = useState(false);
  const [readOnlyCountry, setReadOnlyCountry] = useState(false);
  const [readOnlyPhoneNumber, setReadOnlyPhoneNumber] = useState(false);
  const classes = useStyles();

  const [updateBrand] = useMutation(EDIT_BRAND);

  const handleChange = (set, event) => {
    if (event.target.value || event.target.value === '' || event.target.value === 0) {
      set(event.target.value);
    }
  };

  const queryBrand = useQuery(GET_BRAND_BY_ID, {
    variables: {
      id: brandId,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (save) {
      updateBrand({
        variables: {
          id: brandId,
          name,
          website,
          address,
          state,
          country,
          phoneNumber,
        },
      });
    }
  }, [save, updateBrand]);

  useEffect(() => {
    if (queryBrand && queryBrand.data) {
      const { data: { brand: { name, website, address, state, country, phoneNumber } } } = queryBrand;
      setName(name);
      setWebsite(website);
      setAddress(address);
      setState(state);
      setCountry(country);
      setPhoneNumber(phoneNumber);

      website && setReadOnlyWebsite(true);
      address && setReadOnlyAddress(true);
      state && setReadOnlyState(true);
      country && setReadOnlyCountry(true);
      phoneNumber && setReadOnlyPhoneNumber(true);
    }
  }, [queryBrand]);

  if (!name) return (<></>);
  return (
    <Box mt={5}>
      <Accordion elevation={3}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="brand-accordion-content"
          id="brand-accordion-header"
        >
          <Box className={classes.headerAccordion}>
            <BusinessOutlined />
            {`Brand ‣ ${name}`}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <TextField
              id="website"
              label="Website"
              value={website}
              className={classes.textField}
              onChange={(e) => handleChange(setWebsite, e)}
              InputProps={{
                readOnly: readOnlyWebsite,
              }}
              required
            />
            <TextField
              id="address"
              label="Address"
              value={address}
              className={classes.textField}
              onChange={(e) => handleChange(setAddress, e)}
              InputProps={{
                readOnly: readOnlyAddress,
              }}
              required
            />
            <TextField
              id="state"
              label="State"
              value={state}
              className={classes.textField}
              onChange={(e) => handleChange(setState, e)}
              InputProps={{
                readOnly: readOnlyState,
              }}
              required
            />
            <TextField
              id="country"
              label="Country"
              value={country}
              className={classes.textField}
              onChange={(e) => handleChange(setCountry, e)}
              InputProps={{
                readOnly: readOnlyCountry,
              }}
              required
            />
            <TextField
              id="phone"
              label="Phone Number"
              type="number"
              value={phoneNumber}
              className={classes.textField}
              onChange={(e) => handleChange(setPhoneNumber, e)}
              InputProps={{
                readOnly: readOnlyPhoneNumber,
              }}
              required
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default React.memo(Brand);
